<template>
 <div class="page-wrapper">
    <table-list
        :columns="columns"
        :data="data"
        :loading="loading"
        :slotSpan="6"
        :tableSpan="18"
        :mt36="false"
        :showPage="false"
    >
    <div class="tree">
      <Tree ref="tree" :data="treeData" @on-select-change="getList" ></Tree>
    </div>
    </table-list>
  </div>
</template>

<script type="text/ecmascript-6">
import { goodsInfoMenu,goodsInfoList } from 'api/goods'
import TableList from 'components/TableList/index';
export default {
    name:'category',
    components: {
      TableList
    },
    data(){
      return {
        treeData:[],
        loading:true,
        params:{
          bigGoodsCode:null,
          smallGoodsCode:null
        },
        columns:[
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title:'类目编号',
            align:'center',
            key:'value'
          },
          {
            title:'名称',
            align:'center',
            key:'text'
          },
          {
            // status===0已关闭, status===1已启用
            title:'状态',
            align:'center',
            key:'status',
            render:(h,params)=>{
              return h('div',{
                'class': {
                  green: params.row.status,
                  red: !params.row.status
                }
              },
              '')
            }
          },
          {
            title:'操作',
            align:'center',
            key:'action',
            render: (h,params)=>{
              return h('div','')
            }
          }
        ],
        data:[]
      }
    },
    methods:{
      getList(val){
        if( val[0] && !val[0].children){
          if(this.params.bigGoodsCode===val[0].parentValue &&
          this.params.smallGoodsCode === val[0].value ) return
          this.loading = true
          this.params.bigGoodsCode = val[0].parentValue
          this.params.smallGoodsCode = val[0].value
          goodsInfoList(this.params).then(res => {
            this.loading = false
            this.data = res.data
          })
        } else if (val[0] && val[0].children){
          this.data = val[0].children
          this.params.bigGoodsCode=''
          this.params.smallGoodsCode=''
        }
      },
      initTableData() {

      },
      addKey(o,new_key,old_key) {
        Object.defineProperty(o, new_key,
          Object.getOwnPropertyDescriptor(o, old_key));
      },
      toTreeData(array) {
        array.forEach(item => {
          if(item.children){
            item.children.forEach(child => {
              if(!child) return
              this.addKey(child,'title','text')
              child.parentValue = item.value
            })
          }
          this.addKey(item,'title','text')
        })
      }
    },
    mounted(){
      //this.initData(this.treeData)
      goodsInfoMenu().then( res => {
        this.treeData = res.data
        this.data = this.treeData
        this.loading =  false
        this.toTreeData(this.treeData)
      })
    }

}
</script>

<style lang="css" scoped>
  .tree {
    border:1px solid #ddd;
  }
</style>
